const Styles = {
  textContainerStyle: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    flexDirection: 'column'
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/Login/styles.js